import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

interface AgreeBlockProps {
  className?: string;
}

const AgreeBlock = ({
  children,
  className = '',
}: LT.WithChildren<AgreeBlockProps>): JSX.Element => {
  const [isOverflowingHeight, setIsOverflowingHeight] = useState(false);
  const [isExpand, setIsExpand] = useState(false);

  const refCheckOverflowingHeight = useRef<HTMLDivElement>(null);

  // Проверка на переполнение блока по вертикали
  useEffect(() => {
    if (refCheckOverflowingHeight.current) {
      const { clientHeight, scrollHeight } = refCheckOverflowingHeight.current;
      const isOverflow = clientHeight < scrollHeight;
      setIsOverflowingHeight(isOverflow);
    }
  }, [refCheckOverflowingHeight]);

  const handleExpandContent = () => {
    setIsExpand(true);
  };

  return (
    <StyledContainer className={className}>
      <div>
        <StyledContent
          ref={refCheckOverflowingHeight}
          onClick={isOverflowingHeight ? handleExpandContent : undefined}
          isExpand={isExpand}
        >
          {isOverflowingHeight && !isExpand ? <OverflowBlur /> : null}
          {children}
        </StyledContent>
      </div>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

const OverflowBlur = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(0deg, #f5f3f2 0%, rgba(245, 243, 242, 0) 100%);
`;

const StyledContent = styled.div<{ isExpand: boolean }>`
  font-size: 12px;
  color: var(--grey1);
  position: relative;
  height: ${({ isExpand }) => (isExpand ? 'auto' : '80px')};
  overflow: hidden;
  a {
    text-decoration: none;
    color: var(--black);
    transition: 200ms all ease-in;

    &:hover,
    &:active {
      color: var(--orange);
    }
  }
`;

export default React.memo(AgreeBlock);
